<mat-sidenav-container class="container">
  <mat-sidenav
    mode="side"
    opened
    class="sidenav flex-justify-center flex-align-it-center"
  >
    <mat-nav-list class="no-padding-top">
      <div class="spacer">.</div>
      <a
        mat-list-item
        class="contrast-text"
        routerLink="/dashboard/product-search"
        i18n="@@search-options"
        >Search Options</a
      >
      <a
        mat-list-item
        class="contrast-text"
        [routerLink]="templateUploader ? '/dashboard/template-upload' : null"
        [disabled]="!templateUploader"
        i18n="@@template-upload"
        >Template Upload</a
      >
      <a
        mat-list-item
        class="contrast-text"
        [routerLink]="templateUploader ? '/dashboard/assign-template' : null"
        [disabled]="!templateUploader"
        i18n="@@assign-template"
        >Assign Template</a
      >
      <mat-expansion-panel
        class="primary-color"
        [class.mat-elevation-z0]="true"
      >
        <mat-expansion-panel-header
          class="item subcategories"
          i18n="@@financing-admin"
        >
          Financing Admin
        </mat-expansion-panel-header>
        <mat-nav-list>
          <div>
            <a
              class="contrast-text"
              mat-list-item
              [routerLink]="
                financingAdmin
                  ? '/dashboard/financing-admin/financing-formula'
                  : null
              "
              [disabled]="!financingAdmin"
            >
              <span i18n="@@formula-editor">Formula editor</span>
            </a>
            <a
              class="contrast-text"
              mat-list-item
              [routerLink]="
                financingAdmin
                  ? '/dashboard/financing-admin/bank-management'
                  : null
              "
              [disabled]="!financingAdmin"
            >
              <span i18n="@@bank-editor">Bank editor</span>
            </a>
            <a
              class="contrast-text"
              mat-list-item
              [routerLink]="
                financingAdmin
                  ? '/dashboard/financing-admin/financing-option'
                  : null
              "
              [disabled]="!financingAdmin"
            >
              <span i18n="@@create-financing-options"
                >Create financing options</span
              >
            </a>
            <a
              class="contrast-text"
              mat-list-item
              [routerLink]="
                financingAdmin
                  ? '/dashboard/financing-admin/financing-option/assign-option'
                  : null
              "
              [disabled]="!financingAdmin"
            >
              <span i18n="@@assign-financing-options"
                >Assign financing options</span
              >
            </a>
          </div>
        </mat-nav-list>
      </mat-expansion-panel>
      <mat-expansion-panel
        class="primary-color"
        [class.mat-elevation-z0]="true"
      >
        <mat-expansion-panel-header
          class="item subcategories"
          i18n="@@master-data"
        >
          Master Data
        </mat-expansion-panel-header>
        <mat-nav-list>
<!-- Not needed in 0.5 -->
<!--          <a-->
<!--            class="contrast-text"-->
<!--            mat-list-item-->
<!--            [routerLink]="-->
<!--              masterData ? '/dashboard/master-data/product-group' : null-->
<!--            "-->
<!--            [disabled]="!masterData"-->
<!--          >-->
<!--            <span i18n="@@product-group">Product Group</span>-->
<!--          </a>-->
          <a
            class="contrast-text"
            mat-list-item
            [routerLink]="
              masterData && multilingualism
                ? '/dashboard/master-data/multilingualism'
                : null
            "
            [disabled]="!(masterData && multilingualism)"
          >
            <span i18n="@@multilingualism">Multilingualism</span>
          </a>
          <a
            class="contrast-text"
            mat-list-item
            [routerLink]="
              masterData || featureAdmin
                ? '/dashboard/master-data/feature-admin'
                : null
            "
            [disabled]="!(masterData || featureAdmin)"
          >
            <span i18n="@@feature-admin">Feature Admin</span>
          </a>
        </mat-nav-list>
      </mat-expansion-panel>

      <mat-expansion-panel
        class="primary-color"
        [class.mat-elevation-z0]="true"
      >
        <mat-expansion-panel-header
          class="item subcategories"
          i18n="@@additional-label-information"
        >
          Additional Label Information
        </mat-expansion-panel-header>
        <mat-nav-list>
          <a
            class="contrast-text"
            mat-list-item
            [routerLink]="
              fileUploader
                ? '/dashboard/additional-label-information/file-upload'
                : null
            "
            [disabled]="!fileUploader"
          >
            <span i18n="@@file-upload">File Upload</span>
          </a>
          <a
            class="contrast-text"
            mat-list-item
            [routerLink]="
              fileUploader
                ? '/dashboard/additional-label-information/upload-overview'
                : null
            "
            [disabled]="!fileUploader"
          >
            <span i18n="@@upload-overview">Upload Overview</span>
          </a>
        </mat-nav-list>
      </mat-expansion-panel>
    </mat-nav-list>
  </mat-sidenav>

  <mat-sidenav-content style="flex: 1">
    <router-outlet></router-outlet>
  </mat-sidenav-content>
</mat-sidenav-container>
